import Swiper from 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.mjs'
if (!customElements.get('reviews-slider')) {
  class ReviewsSlider extends HTMLElement {
    constructor() {
      super();
      this.setVeraibles();
      this.setEvens();
      this.initSwiper();
    }
    setVeraibles(){
      this.swiperElement = this.querySelector("[data-reviews-swiper]");
      this.nextButtonElement = this.swiperElement.querySelector("[data-button-next]");
      this.prevButtonElement = this.swiperElement.querySelector("[data-button-prev]");
      this.paginationElement = this.swiperElement.querySelector("[data-swiper-pagination]")
    }
    setEvens(){

    }

    initSwiper(){
      this.swiper = new Swiper(this.swiperElement, {
        navigation: {
          nextEl: this.nextButtonElement,
          prevEl: this.prevButtonElement,
        },
        pagination: {
          el: this.paginationElement,
          clickable: true,
        },
      });
    }
  }
  customElements.define('reviews-slider', ReviewsSlider);
}